import { Mixins, Component, Emit } from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/exam';
import apiCommon from '@/api/app';
import { COMMON_DATA_TYPE } from '@/libs/config';
import { ExamTypeEnum } from '@/libs/config';
import pageMixin from '../../../mixins/pageMixin';
import { Message } from '@/plugin/message/index';

@Component
export default class tableMixin extends Mixins(pageMixin) {
  private cList: any = [];

  private courseType: any = [];

  private removeOrRestore = '删除'

  private column: Array<ITABLECOLCONF> = [
    {
      label: '题库编号',
      prop: 'serial',
      align: 'center',
      width: '180px',
      tooltip: true,
    },{
    label: '题库名称',
    prop: 'subjectName',
    align: 'left',
    width: '180px',
    tooltip: true,
  },{
      label: '题库类型',
      custom: true,
      prop: 'status',
      align: 'center',
      width: '120px',
      tags: [{
        value: '1',
        type: 'warning',
        label: '作废',
      }, {
        value: '0',
        type: 'success',
        label: '有效',
      }],
    },{
    label: '判断题数量',
    prop: 'judgeCount',
    align: 'center',
    width: '100px',
    tooltip: true,
  }, {
    label: '单选题数量',
    prop: 'radioCount',
    align: 'center',
    width: '100px',
    tooltip: true,
  }, {
    label: '多选题数量',
    prop: 'multipleCount',
    align: 'center',
    width: '100px',
    tooltip: true,
  },
  // }, {
  //   label: '课程类型',
  //   prop: 'courseName',
  //   align: 'center',
  //   tooltip: true,
  // },
  {
    label: '题库备注',
    prop: 'subjectRemark',
    align: 'left',
    tooltip: true,
  }, {
    label: '创建时间',
    prop: 'createAt',
    align: 'left',
    width: '150px',
  }, {
    label: '操作',
    custom: true,
    minWidth: '120px',
    align: 'center',
    maxBtn: 1,
    btnList: [
      {
        title: '查看详情',
        name: '/ques/info:chapter',
        icon: 'edit',
        type: 'info',
        callback: this.handleWors,
        log: {
          name: '题库管理 - 查看详情',
          component: '/ques/info:chapter',
        },
      },
      {
        title: '修改',
        name: '/ques/info:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleEdit,
        log: {
          name: '题库管理 - 修改',
          component: '/ques/info:update',
        },
      },
      {
        title: '删除',
        name: '/ques/info:remove',
        icon: 'trash-o',
        type: 'info',
        callback: this.handleRemove,
        log: {
          name: '题库管理 - 删除',
          component: '/ques/info:update',
        },
      },
    ],
  }]

  private loading: boolean = false;

  private questionType: any = [];

  // private removeOrDelete: string = ''

  init() {
    apiCommon.getBaseDataByType([COMMON_DATA_TYPE.QUESTION, COMMON_DATA_TYPE.CourseType]).then((res: any) => {
      this.questionType = res.question;
      this.courseType = res.CourseType;
    });
  }

  /**
   * @author liuyongchun
   * @desc 获取课程信息列表
   */
  getData(params?: any) {
    if (params.status !== '0') {
      this.column[8]
        && this.column[8].btnList
        && this.column[8].btnList[2]
        && (this.column[8].btnList[2].title = '恢复')
    } else {
      this.column[8]
        && this.column[8].btnList
        && this.column[8].btnList[2]
        && (this.column[8].btnList[2].title = '删除')
    }
    this.loading = true;
    this.page.params = params;
    const data = { pageSize: this.page.pageSize, pageNo: this.page.pageNo, ...this.page.params };
    api.pageGetQuesBank(data).then((res: any) => {
      if(res && Array.isArray(res.content)) {
        res.content.forEach((quesItem: any) => {
          if(Array.isArray(quesItem.items)) {
            quesItem.items.forEach((quesTypeItem: any) => {
              if (ExamTypeEnum.JUDGE === quesTypeItem.value) {
                quesItem.judgeCount = quesTypeItem.number;
              } else if (ExamTypeEnum.RADIO === quesTypeItem.value) {
                quesItem.radioCount = quesTypeItem.number;
              } else if (ExamTypeEnum.MULTIPLE === quesTypeItem.value) {
                quesItem.multipleCount = quesTypeItem.number;
              }
            })
          }
          // const course = this.courseType.find((courseItem: any) => {
          //   quesItem.subjectId === courseItem.id
          // })
          // if (course) {
          //   quesItem.courseName = course.label;
          // } else {
          //   quesItem.courseName = '暂无';
          // }
        })
      }
      this.cList = res.content;
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  /**
   * @author liuyongchun
   * @desc 打开课程章节
   * @param { any } row 行数据
   */
  handleWors(row: any) {
    this.$router.push({ name: 'exam/quesDetail', params: { pid: row.id, type: 'Resource' } });
  }

  handleEdit(row: any) {
    // @ts-ignore
    this.editItem(row);
  }

  /**
   * @author liuyongchun
   * @desc 删除题库事件
   * @params { any } row 行数据
   */
  handleRemove(row: any) {
    if (row.status === '0') {
    this.confirm('您确定要删除该题库?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeQuesBank(row.id).then(() => {
        this.getData({status: row.status});
        close();
        this.$log({
          title: '题库管理 - 删除 - 确定',
          component: 'exams/questions',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '题库管理 - 删除 - 取消',
      component: 'exams/questions',
    }));
    } else {
      this.confirm('您确定要恢复该题库?', {
        title: '警告',
        loading: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconType: 'warning',
      }).then((close: Function) => {
        api.removeQuesBank(row.id).then(() => {
          this.getData({status: row.status});
          close();
          this.$log({
            title: '题库管理 - 恢复 - 确定',
            component: 'exams/questions',
          });
        }).catch(() => close());
      }).catch(() => this.$log({
        title: '题库管理 - 恢复 - 取消',
        component: 'exams/questions',
      }));
    }
  }
}
